// @ts-nocheck
import React, { useState, useEffect, useContext, useMemo } from 'react';
import { colors, shadows } from '@/theme';
import LegacyButton from '@/components/button';
import Fetch from '@/utils/Fetch';
import Time from '@/utils/time';
import Helper from '@/utils/helper';
import * as Enums from '@/utils/enums';
import ToastContext from '@/utils/toast-context';
import ConfirmAction from '@/components/modals/confirm-action';
import DownloadService from '@/utils/download-service';
import BusyIndicatorContext from '@/utils/busy-indicator-context';
import Constants from '@/utils/constants';
import OptionService from '@/services/option/option-service';
import { useRef } from 'react';
import formService from '@/services/form/form-service';
import SCInput from '@/components/sc-controls/form-controls/sc-input';
import SCTextArea from '@/components/sc-controls/form-controls/sc-textarea';
import SCNumericInput from '@/components/sc-controls/form-controls/sc-numeric-input';
import SCCheckbox from '@/components/sc-controls/form-controls/sc-checkbox';
import SCDropdownList from '@/components/sc-controls/form-controls/sc-dropdownlist';
import SCDatePicker from '@/components/sc-controls/form-controls/sc-datepicker';
import SCTimePicker from '@/components/sc-controls/form-controls/sc-timepicker';
import SCMultiSelect from '@/components/sc-controls/form-controls/sc-multiselect';
import PreviewAttachment from "@/components/modals/attachment/preview-attachment";
import Image from "next/image";
import SignatureModal from '@/PageComponents/Signature/SignatureModal';
import useInitialTimeout from '@/hooks/useInitialTimeout';
import helper from '@/utils/helper';
import storage from '@/utils/storage';
import SCModal from "@/PageComponents/Modal/SCModal";
import SCSpinner from "@/components/sc-controls/misc/sc-spinner";
import {Box, Button, Flex, Text, Title} from '@mantine/core';
import { IconCirclePlus } from "@tabler/icons-react";

function ManageForm({ onSave, formHeaderToManage, isNew, onRenew }: any) {

  const toast = useContext(ToastContext);
  const busyIndicator = useContext(BusyIndicatorContext);

  const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

  const [formDefinitionFields, setFormDefinitionFields] = useState<any[]>([]);

  const [formHeader, setFormHeader] = useState(formHeaderToManage);
  const [formItems, setFormItems] = useState(isNew ? [] : formHeaderToManage.FormItems);

  const [retrievedFields, setRetrievedFields] = useState(false);
  const [formItemsChanged, setFormItemsChanged] = useState(0);
  const [sectionsToRender, setSectionsToRender] = useState<any[]>([]);
  const [formDataOptions, setFormDataOptions] = useState<any[]>([]);
  const [imageUploadMessage, setImageUploadMessage] = useState<any>({});
  const [isPrinting, setIsPrinting] = useState(false);

  const [signatureObject, setSignatureObject] = useState<any>(null);

  const getFormDataOptions = async () => {
    const response = await formService.getFormDataOptions({
      formDefinitionMasterID: formHeader.FormDefinition.MasterID,
      toastCtx: toast
    });

    setFormDataOptions(response.Results);
  }

  const getFormDefinitionFields = async (formHeaderToRetrieve: any) => {
    const request = await Fetch.get({
      url: `/FormDefinition/GetFormDefinitionFields`,
      params: {
        formDefinitionID: formHeaderToRetrieve.FormDefinitionID,
        includeInactive: true
      },
    });

    let fields = request.Results;

    if (!isNew && formHeaderToRetrieve && formHeaderToRetrieve.FormItems) {
      formHeaderToRetrieve.FormItems.forEach((item: any) => {
        let field = fields.find((x: any) => x.ID === item.FormDefinitionFieldID);
        if (item.IsActive && field && !field.IsActive) {
          field.IsActive = true;
        }
      });
    }

    fields = fields.filter((x: any) => x.IsActive);

    setFormDefinitionFields(fields);
    setRetrievedFields(true);
  };

  useEffect(() => {
    if (retrievedFields && isNew) {
      setEmptyFields();
    }
    getSectionsToRender();
  }, [retrievedFields]);

  useEffect(() => {
    getSectionsToRender();
  }, [formItemsChanged]);

  const [imageSrcs, setImageSrcs] = useState(0);
  const imageSrcRef = useRef({});

  const getImgSrc = (attachmentID: any) => {

    if (!attachmentID || attachmentID.length !== 36) {
      return "";
    }

    let src = imageSrcRef.current[attachmentID];
    if (src && src !== "PENDING") {
      return src;
    }

    if (src === "PENDING") {
      return "";
    }

    imageSrcRef.current[attachmentID] = "PENDING";

    Fetch.get({
      url: '/Attachment',
      params: {
        id: attachmentID
      }
    }).then((attachment: any) => {
      if (attachment && attachment.Url) {
        imageSrcRef.current[attachmentID] = attachment.Url;
        setImageSrcs((x: any) => x + 1);
      }
    });
  };

  const getBlankFormItemFromField = (field: any, defaultSectionGroup = 0) => {
    let item = {};
    (item as any).ID = Helper.newGuid();
    (item as any).FormDefinitionFieldID = field.ID;
    (item as any).DisplayOrder = field.DisplayOrder;
    (item as any).Section = field.Section;
    (item as any).Description = field.Description;
    (item as any).Line = null;
    (item as any).SectionGroup = (item as any).Section && (item as any).Section.Repeatable === true ? defaultSectionGroup : null;
    (item as any).DataType = field.DataType;
    (item as any).Required = field.Required;
    (item as any).SectionID = field.SectionID;
    (item as any).SectionHeading = field.Section ? field.Section.Heading : null;
    (item as any).SectionDescription = field.Section ? field.Section.Description : null;
    (item as any).SectionRepeatable = field.Section ? field.Section.Repeatable : null;
    (item as any).SectionDisplayOrder = field.Section ? field.Section.DisplayOrder : null;
    (item as any).ParentSectionID = field.Section ? field.Section.ParentSectionID : null;
    (item as any).ParentSectionGroup = 0;
    (item as any).CreatedDate = Time.toISOString(Time.now());
    (item as any).ModifiedDate = Time.toISOString(Time.now());
    (item as any).CreatedBy = storage.getCookie(Enums.Cookie.servUserName);
    (item as any).ModifiedBy = storage.getCookie(Enums.Cookie.servUserName);

    switch (field.DataType) {
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.LongText):
        (item as any).DataResult = '';
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.String):
        (item as any).DataResult = '';
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Number):
        (item as any).DataResult = null;
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Checkbox):
        (item as any).DataResult = 'false';
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Date):
        (item as any).DataResult = '';
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.DateTime):
        (item as any).DataResult = '';
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Select):
        (item as any).DataResult = '';
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.MultiSelect):
        (item as any).DataResult = '';
        break;
      default:
        (item as any).DataResult = '';
    }

    (item as any).IsActive = true;
    return item;
  };

  const getBlankFormItemFromOtherItem = (originalItem: any, defaultSectionGroup = 0, defaultParentSectionGroup = 0) => {
    let item = {};
    (item as any).ID = Helper.newGuid();
    (item as any).FormDefinitionFieldID = originalItem.FormDefinitionFieldID;
    (item as any).DisplayOrder = originalItem.DisplayOrder;
    (item as any).Section = originalItem.Section;
    (item as any).Description = originalItem.Description;
    (item as any).Line = null;
    (item as any).SectionGroup = originalItem.SectionRepeatable === true ? defaultSectionGroup : null;
    (item as any).DataType = originalItem.DataType;
    (item as any).Required = originalItem.Required;
    (item as any).SectionID = originalItem.SectionID;
    (item as any).SectionHeading = originalItem.SectionHeading;
    (item as any).SectionDescription = originalItem.SectionDescription;
    (item as any).SectionRepeatable = originalItem.SectionRepeatable;
    (item as any).SectionDisplayOrder = originalItem.SectionDisplayOrder;
    (item as any).ParentSectionID = originalItem.ParentSectionID;
    (item as any).ParentSectionGroup = defaultParentSectionGroup;

    switch ((item as any).DataType) {
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.LongText):
        (item as any).DataResult = '';
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.String):
        (item as any).DataResult = '';
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Number):
        (item as any).DataResult = null;
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Checkbox):
        (item as any).DataResult = 'false';
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Date):
        (item as any).DataResult = '';
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.DateTime):
        (item as any).DataResult = '';
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Select):
        (item as any).DataResult = '';
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.MultiSelect):
        (item as any).DataResult = '';
        break;
      default:
        (item as any).DataResult = '';
    }

    (item as any).IsActive = true;
    return item;
  };


  const setEmptyFields = () => {

    let items = [];
    formDefinitionFields.forEach((x: any) => {
      let item = getBlankFormItemFromField(x);
      items.push(((item as any) as any));
    });
    setFormItems(items);
    setFormItemsChanged(formItemsChanged + 1);
  };

  useEffect(() => {
    getFormDataOptions();
    getFormDefinitionFields(formHeaderToManage);
  }, []);

  useInitialTimeout(50, () => {
    ignoreFormHeaderToManageChanges.current = false;
  });

  const ignoreFormHeaderToManageChanges = useRef(true);

  useEffect(() => {
    if (ignoreFormHeaderToManageChanges.current) return;
    setFormHeader(formHeaderToManage);
    setFormItems(formHeaderToManage.FormItems);
  }, [formHeaderToManage]);

  const handleFormItemChange = (e: any, item: any) => {
    item.DataResult = e.target.value;
    let otherItems = formItems.filter((x: any) => x.ID != item.ID);

    setFormItems([...otherItems, item]);
  };

  const handleFormItemChangeSC = (e: any, item: any) => {
    item.DataResult = e.value?.toString();
    let otherItems = formItems.filter((x: any) => x.ID != item.ID);

    setFormItems([...otherItems, item]);
  };

  const handleCheckboxFormItemChange = (item: any) => {

    item.DataResult = !Helper.stringToBool(item.DataResult) ? "true" : "false";
    let otherItems = formItems.filter((x: any) => x.ID != item.ID);

    setFormItems([...otherItems, item]);
  };

  const handleDateFormItemChangeSC = (e: any, item: any, setMethod = null) => {
    item.DataResult = Time.toISOString(e.value, false, true);

    if (setMethod) {
      setMethod(item.DataResult);
    } else {
      let otherItems = formItems.filter((x: any) => x.ID != item.ID);
      setFormItems([...otherItems, item]);
    }
  };

  const handleDateFormItemChange = (e: any, item: any, setMethod = null) => {
    item.DataResult = Time.toISOString(e, false, true);

    if (setMethod) {
      setMethod(item.DataResult);
    } else {
      let otherItems = formItems.filter((x: any) => x.ID != item.ID);
      setFormItems([...otherItems, item]);
    }
  };

  const handleAttachmentChange = (e: any, item: any, setMethod = null) => {
    busyIndicator.setText!!!("Uploading...");

    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = async function () {

      let fileSizeSetting = await OptionService.getOption('System Settings', 'File Upload Size');
      let fileSizeUnit = fileSizeSetting ? (fileSizeSetting as any).Unit : 'mb';
      let fileSizeValue = fileSizeSetting ? parseInt((fileSizeSetting as any).OptionValue) : 2;

      if (!(reader.result as any).startsWith("data:image/")) {
        toast.setToast!!!({
          message: `The attachment must be an image`,
          show: true,
          type: Enums.ToastType.error
        });
        busyIndicator.setText!!!(null);
        return;
      }

      var b64 = (reader.result as any).replace(/^data:.+;base64,/, '');
      let uploadLength = 2;

      if (fileSizeUnit == 'kb') {
        uploadLength = b64.length / 1024;
      } else if (fileSizeUnit == 'mb') {
        uploadLength = b64.length / 1024 / 1024;
      } else if (fileSizeUnit == 'gb') {
        uploadLength = b64.length / 1024 / 1024 / 1024;
      }

      // base64 converts 6bits to 8bits when encoding, so the actual file size is 3/4
      let scalingFactor = Constants.base64BitScalingFactor;
      uploadLength *= scalingFactor;

      if (uploadLength > parseFloat((fileSizeValue as any))) {
        toast.setToast!!!({
          message: `The attachment must be smaller than ${fileSizeValue}${fileSizeUnit}`,
          show: true,
          type: 'error'
        });
      } else {
        const attachmentRes = await Fetch.post({
          url: '/Attachment',
          params: {
            AttachmentType: Enums.AttachmentType.Image,
            Description: file.name,
            FileName: file.name,
            FileBase64: b64,
            ItemID: formHeaderToManage.ID,
            Module: Enums.Module.FormHeader,
          },
          toastCtx: toast
        });

        if (attachmentRes.ID) {
          //   ...imageUploadMessage,
          //   [item.ID]: "✓"
          //   message: 'Attachment uploaded successfully',
          //   show: true,
          //   type: 'success'
          item.DataResult = attachmentRes.ID;

          if (setMethod) {
            setMethod(item.DataResult)
          } else {
            let otherItems = formItems.filter((x: any) => x.ID != item.ID);
            setFormItems([...otherItems, item]);
          }
        }
      }

      busyIndicator.setText!!!(null);
    };
    reader.readAsDataURL(file);
  };

  const handleDateTimeFormItemChangeSC = (e: any, item: any, setMethod = null) => {
    if (!item.DataResult) {
      item.DataResult = Time.toISOString(new Date(), false, true);
    }
    let updatedDate = Time.updateTime(item.DataResult, e.value);
    item.DataResult = Time.toISOString(updatedDate, false, true);

    if (setMethod) {
      setMethod(item.DataResult)
    } else {
      let otherItems = formItems.filter((x: any) => x.ID != item.ID);
      setFormItems([...otherItems, item]);
    }
  };

  const handleDateTimeFormItemChange = (e: any, item: any, setMethod = null) => {
    if (!item.DataResult) {
      item.DataResult = Time.toISOString(new Date(), false, true);
    }
    let updatedDate = Time.updateTime(item.DataResult, e);
    item.DataResult = Time.toISOString(updatedDate, false, true);

    if (setMethod) {
      setMethod(item.DataResult)
    } else {
      let otherItems = formItems.filter((x: any) => x.ID != item.ID);
      setFormItems([...otherItems, item]);
    }
  };

  const timePickerDisabled = (item: any) => {
    return item ? Helper.isNullOrUndefined(item.DataResult) : true;
  };

  const getValueWithoutField = (item: any) => {
    let result;
    switch (item.DataType) {
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.String):
        result = item ? item.DataResult : '';
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.LongText):
        result = item ? item.DataResult : '';
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Number):
        result = item ? parseFloat(item.DataResult) : null;
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Checkbox):
        result = item ? Helper.stringToBool(item.DataResult) : false;
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Date):
        result = item ? item.DataResult : null;
        break;
      default:
        result = item ? item.DataResult : '';
    }

    return !Helper.isNullOrWhitespace(result) ? result : '';
  };

  const getDateTimeValue = (item: any, isDate = true) => {
    let result;

    if (isDate) {
      result = item ? !Helper.isNullOrWhitespace(item.DataResult) ? Time.toISOString(item.DataResult, false, false) : null : null;
    } else {
      if (item.DataResult === 'NaN-NaN-NaN NaN:NaN:NaN') {
        result = null
      } else {
        result = item ? !Helper.isNullOrWhitespace(item.DataResult) ? item.DataResult : null : null;
      }
    }

    return result;
  };

  const getValueMultiple = (item: any) => {
    let options = getSelectedDataOptions(item);
    return options ? options.join(", ") : '';
  };

  const setValue = (option: any, item: any) => {
    item.DataResult = option;

    let otherItems = formItems.filter((x: any) => x.ID !== item.ID);
    setFormItems([...otherItems, item]);
  };

  const setValueMultipleSC = (options: any, item: any, setValueMethod = setValue) => {
    let vals = options;

    let val = "";
    if (vals.length > 0) {
      val = Helper.serializeCustomCSV(vals);
    }
    setValueMethod(val, item);
  };

  const setValueMultiple = (option: any, item: any, setValueMethod = setValue) => {
    let vals = getSelectedDataOptions(item);
    let idx = vals.indexOf(option);
    if (idx > -1) {
      vals.splice(idx, 1);
    } else {
      vals.push(option);
    }

    let val = "";
    if (vals.length > 0) {
      val = Helper.serializeCustomCSV(vals);
    }
    setValueMethod(val, item);
  };

  const getSelectedDataOptions = (item: any) => {
    return item ? Helper.deserializeCustomCSV(item.DataResult) : '';
  };

  const getDataOptions = (field: any) => {
    if (!field) return [];

    let dataOption = field.DataOption;
    if (formDataOptions) {
      const match = formDataOptions.find((x: any) => x.ItemMasterID === field.MasterID);
      if (match) {
        dataOption = match.DataOption;
      }
    }
    return Helper.deserializeCustomCSV(dataOption);
  };

  const [inputErrors, setInputErrors] = useState<any>({});

  const parseTableDataResultSafely = (dataResult: any) => {
    try {
      return JSON.parse(dataResult);
    } catch {
      return {
        Rows: []
      };
    }
  };

  const validate = () => {

    let validationItems = [];

    let formItemsToValidate = [...formItems];
    let tableItems = formItemsToValidate.filter((x: any) => x.DataType === Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Table));

    tableItems.forEach((item: any) => {
      let field = formDefinitionFields.find((x: any) => x.ID === item.FormDefinitionFieldID);
      let design = JSON.parse(field.DataOption);
      let values = parseTableDataResultSafely(item.DataResult);
      design.ColumnDefinitions.forEach((colDef: any, colIdx: any) => {
        if (colDef.Required && colDef.DataType !== Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Checkbox)) {
          values.Rows.forEach((row: any, rowIdx: any) => {
            let rowDef = design.RowDefinitions.find((x: any) => x.Name === row.RowName);
            let col = row.Columns.find((x: any) => x.ColumnName === colDef.Name);
            formItemsToValidate.push({
              ID: getTableCellID(colDef.Name, rowDef ? rowDef.Name : "", rowDef ? "" : rowIdx, item.SectionGroup),
              DataResult: col ? col.Value : null,
              Required: colDef.Required,
              DataType: colDef.DataType
            });
          });
        }
      });
    });

    for (let index in formItemsToValidate) {
      let item = formItemsToValidate[index];
      if (item.Required) {

        switch (item.DataType) {
          case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.String):
            validationItems.push(
              { key: item.ID, value: item.DataResult, required: true, type: Enums.ControlType.Text },
            );
            break;
          case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.LongText):
            validationItems.push(
              { key: item.ID, value: item.DataResult, required: true, type: Enums.ControlType.Text },
            );
            break;
          case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Number):
            validationItems.push(
              { key: item.ID, value: item.DataResult, required: true, type: Enums.ControlType.Number },
            );
            break;
          case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Date):
            validationItems.push(
              { key: item.ID, value: item.DataResult, required: true, type: Enums.ControlType.Date },
            );
            break;
          case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.DateTime):
            validationItems.push(
              { key: item.ID, value: item.DataResult, required: true, type: Enums.ControlType.Date },
            );
            break;
          case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Select):
            validationItems.push(
              { key: item.ID, value: item.DataResult, required: true, type: Enums.ControlType.Select },
            );
            break;
          case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.MultiSelect):
            validationItems.push(
              { key: item.ID, value: item.DataResult, required: true, type: Enums.ControlType.MultiSelect },
            );
            break;
          case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.InformationalText):
          case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.InformationalImage):
            break;
          default:
            validationItems.push(
              { key: item.ID, value: item.DataResult, required: true, type: Enums.ControlType.Text },
            );
        }
      }
    }

    let { isValid, errors } = Helper.validateInputs(validationItems);

    setInputErrors(errors);
    return isValid;
  };

  const [saving, setSaving] = useState(false);

  const save = async (ignoreOnSave = false, formHeaderOverride = null) => {

    if (!formHeaderOverride && formHeader.FormStatus === Enums.FormStatus.Completed) {
      if (!validate()) {
        return;
      }
    }

    let formHeaderToSave = formHeaderOverride ?? formHeader;
    let formItemsToSave = (formHeaderOverride as any)?.FormItems ?? formItems;

    setSaving(true);

    let result = {};
    if (isNew) {
      result = await Fetch.post({
        url: `/Form`,
        params: {
          FormHeader: formHeaderToSave,
          FormItems: formItemsToSave,
          IsNew: isNew
        },
        toastCtx: toast,
      });
    } else {
      result = await Fetch.put({
        url: `/Form`,
        params: {
          FormHeader: formHeaderToSave,
          FormItems: formItemsToSave,
          IsNew: isNew
        },
        toastCtx: toast,
      });
    }

    if ((result as any).ID) {
      !ignoreOnSave && toast.setToast!!!({
        message: 'Form captured successfully',
        show: true,
        type: 'success'
      });

      onSave(ignoreOnSave ? { ...result, _isNew: false } : null)
    }
    setSaving(false);
  };

  const completeCheck = () => {

    let isValid = validate();

    if (!isValid) return;

    setConfirmOptions({
      ...Helper.initialiseConfirmOptions(),
      confirmButtonText: "Complete",
      display: true,
      heading: "Complete the form?",
      text: formHeaderToManage.FormDefinition.ExpireTimespan === 0 ? "" : "Form will not be editable once completed.",
      onConfirm: complete
    });
  };

  const complete = async () => {
    setSaving(true);

    let isValid = validate();

    if (isValid) {
      let result = {};

      let now = Time.now();

      if (isNew) {
        result = await Fetch.post({
          url: `/Form`,
          params: {
            FormHeader: { ...formHeader, FormStatus: Enums.FormStatus.Completed, CompletedDate: Time.toISOString(now) },
            FormItems: formItems,
            IsNew: isNew
          },
          toastCtx: toast,
        });
      } else {
        result = await Fetch.put({
          url: `/Form`,
          params: {
            FormHeader: { ...formHeader, FormStatus: Enums.FormStatus.Completed, CompletedDate: Time.toISOString(now) },
            FormItems: formItems,
            IsNew: isNew
          },
          toastCtx: toast,
        });
      }

      if ((result as any).ID) {
        toast.setToast!!!({
          message: 'Form completed successfully',
          show: true,
          type: 'success'
        });
        onSave(null);
      } else {
        setSaving(false);
      }
    } else {
      toast.setToast!!!({
        message: 'There are errors on the page',
        show: true,
        type: 'error'
      });
      setSaving(false);
    }
  };

  const getTableCellID = (columnName: any, rowName: any, rowIndex: any, sectionGroup = 0) => {
    return `${columnName}_${rowName}_${rowIndex}_${sectionGroup}`;
  };

  const isExpired = () => {
    if (!formHeader || !formHeader.ExpireDate) {
      return false;
    }
    return Time.now().valueOf() > Time.parseDate(formHeader.ExpireDate).valueOf();
  };

  const willExpire = () => {
    if (!formHeader || !formHeader.ExpireDate) {
      return false;
    }
    return Time.now().valueOf() <= Time.parseDate(formHeader.ExpireDate).valueOf();
  };

  const disableField = () => {
    return formHeader.FormStatus === Enums.FormStatus.Completed && (formHeader.FormDefinition.ExpireTimespan !== 0 || formHeader.FormDefinition.FormRule !== Enums.FormRule.Customer);
  }

  const printFormHeader = async (formHeader: any) => {
    setIsPrinting(true);
    DownloadService.downloadFile("GET", `/Form/PrintForm?formHeaderID=${formHeader.ID}`, null, true, false, "", "", null, false, () => {
      setIsPrinting(false);
    });
  };

  const plotFormItemTable = (item: any, field: any) => {
    if (item.DataType !== Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Table) || !field) return <></>;
    let design = field.DataOption && field.DataOption.length > 0 ? JSON.parse(field.DataOption) : null;
    if (design == null) return (<></>);
    let blockLoad = false;

    const labelRows = design.LabelRows;
    const limitRows = design.LimitRows;
    const maximumRows = design.MaximumRows;

    let values = item.DataResult && item.DataResult.length > 0 ? parseTableDataResultSafely(item.DataResult) : { Rows: [] }; // default to blank structure

    const updateItemValue = () => {
      handleFormItemChange({ target: { value: JSON.stringify(values) } }, item);
    }

    const addRow = (rowNames = null) => {
      if (Array.isArray(rowNames)) {
        (rowNames as any).forEach((rowName: any) => {
          values.Rows.push({
            RowName: rowName,
            Columns: []
          });
        });
      } else {
        values.Rows.push({
          RowName: null,
          Columns: []
        });
      }
      updateItemValue();
    };

    const removeRow = (idx: any) => {
      values.Rows.splice(idx, 1);
      updateItemValue();
    };

    if (!labelRows && values.Rows.length === 0) {
      addRow();
      blockLoad = true;
    } else if (labelRows) {
      let rowsToAdd = [];
      let idx = -1;
      design.RowDefinitions.forEach((rowDef: any) => {
        idx = values.Rows.findIndex((x: any) => x.RowName === rowDef.Name);
        if (idx < 0) {
          rowsToAdd.push((rowDef as any).Name);
        }
      });
      if (rowsToAdd.length > 0) {
        addRow((rowsToAdd as any));
        blockLoad = true;
      }
    }

    const canAddOrRemoveRowsCompletedCheck = () => {
      return formHeader.FormStatus !== Enums.FormStatus.Completed || (formHeader.FormDefinition.ExpireTimespan === 0 && formHeader.FormDefinition.FormRule === Enums.FormRule.Customer);
    }

    if (blockLoad) {
      return (<></>);
    }
    return (<div style={{ marginTop: "0.5rem" }}>
      {field.Description ? <b>{field.Description}</b> : ""}
      <table>
        <thead>
          <tr>
            {labelRows ? <th></th> : ""}
            {design.ColumnDefinitions.map((def: any, key: any) => {
              return (<th key={key} className="heading-cell">{def.Label} {def.Required ? <span style={{ color: "#fa5252" }}>*</span> : ""}</th>);
            })}
            {labelRows ? "" : <th></th>}
          </tr>
        </thead>
        <tbody>
          {labelRows ? <>
            {design.RowDefinitions.map((rowDef: any, rowKey: any) => {
              return (<tr key={`row_${rowKey}`}>
                <td key={rowKey} className="heading-cell">{rowDef.Label}</td>
                {design.ColumnDefinitions.map((def: any, key: any) => {
                  let row = values.Rows.find((x: any) => x.RowName === rowDef.Name);
                  let column = row.Columns ? row.Columns.find((x: any) => x.ColumnName === def.Name) : null;
                  let value = column ? column.Value : null;
                  return (<td className="input-cell" key={`${rowKey}_${key}`}>
                    {plotFormItemWithoutField({
                      DataResult: value,
                      DataType: def.DataType,
                      Description: "", //def.Label,
                      Required: def.Required,
                      ID: getTableCellID(def.Name, rowDef.Name, "", item.SectionGroup) // generate id for this field that is unique and can be referenced in validation
                    }, {
                      ColumnDefinition: def,
                      OnUpdate: (newValue: any) => {
                        if (!column) {
                          column = {
                            Value: null,
                            ColumnName: def.Name
                          };
                          row.Columns.push(column);
                        }
                        column.Value = newValue;
                        updateItemValue();
                      }
                    })}
                  </td>);
                })}
              </tr>);
            })}
          </> : <>
            {values.Rows.map((row: any, rowKey: any) => {
              return (<tr key={`row_${rowKey}`}>
                {design.ColumnDefinitions.map((def: any, key: any) => {
                  let column = row.Columns ? row.Columns.find((x: any) => x.ColumnName === def.Name) : null;
                  let value = column ? column.Value : null;
                  return (<td className="input-cell" key={`${rowKey}_${key}`}>
                    {plotFormItemWithoutField({
                      DataResult: value,
                      DataType: def.DataType,
                      Description: "", //def.Label,
                      Required: def.Required,
                      ID: getTableCellID(def.Name, "", rowKey, item.SectionGroup) // generate id for this field that is unique and can be referenced in validation
                    }, {
                      ColumnDefinition: def,
                      OnUpdate: (newValue: any) => {
                        if (!column) {
                          column = {
                            Value: null,
                            ColumnName: def.Name
                          };
                          row.Columns.push(column);
                        }
                        column.Value = newValue;
                        updateItemValue();
                      }
                    })}
                  </td>);
                })}
                {canAddOrRemoveRowsCompletedCheck() && values.Rows.length > 1 ? <td>
                  <img src="/icons/x-circle-red.svg" className="remove-button input-cell blank-cell" onClick={() => removeRow(rowKey)} title="Remove row" />
                </td> : ""}
              </tr>);
            })}
            {canAddOrRemoveRowsCompletedCheck() && (!limitRows || maximumRows > values.Rows.length) ? <>
              <tr>
                <td className="input-cell blank-cell">
                  <img src="/icons/plus-circle-blue.svg" className="add-button" onClick={addRow} title="Add row" />
                </td>
                <td colSpan={design.ColumnDefinitions.length - 1}></td>
              </tr>
            </> : ""}
          </>}
        </tbody>
      </table>

      <style jsx>{`

        .heading-cell {
          padding: 0.75rem;
          background: ${colors.blueGreyLight}88;
          font-weight: bold;
          text-align: center;
        }

        .input-cell {
          padding: 0rem;
          background: ${colors.blueGreyLight}22;
          text-align: center;
          vertical-align: top;
        }

        .input-cell.blank-cell {
          background: none;
        }

        
        .add-button, .remove-button {
          cursor: pointer;
        }

`}</style>
    </div>);
  };

  const [previewAttatchmentItem, setPreviewAttatchmentItem] = useState<any>(null)

  const attachmentPreviewModal = useMemo(() => {
    if (!previewAttatchmentItem) {
      return <></>
    }
    let attachmentID = previewAttatchmentItem.DataResult;
    if (previewAttatchmentItem.DataType === "InformationalImage") {
      attachmentID = previewAttatchmentItem.Description;
    }
    const itemSrc = getImgSrc(attachmentID)
    const attachmentObject = {
      "FileName": attachmentID + ".png",
      "Url": itemSrc,
      "IsActive": true,
    }
    return <PreviewAttachment attachment={attachmentObject}
      setShowAttachmentPreview={() => setPreviewAttatchmentItem(null)}
      overlay
    />
  }, [previewAttatchmentItem])

  const plotFormItemWithoutField = (item: any, tableItemSettings = null) => {
    const itemFromTable = tableItemSettings !== null && tableItemSettings !== undefined;
    let field = itemFromTable ? { ...(tableItemSettings as any).ColumnDefinition, MasterID: (tableItemSettings as any).ColumnDefinition.Name } : formDefinitionFields.find((x: any) => x.ID === item.FormDefinitionFieldID);
    let itemValue = '';
    let onTableCellUpdate = itemFromTable ? (tableItemSettings as any).OnUpdate : null;

    let itemID = Helper.newGuid();
    switch (item.DataType) {
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.DateTime):
        itemValue = getDateTimeValue(item, false);
        break;
      case Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.MultiSelect):
        itemValue = getValueMultiple(item);
        break;
      default:
        itemValue = getValueWithoutField(item);
        break;
    }

    return (
      item.DataType == Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.String) ?
        <div className="row">
          <div className="column">
            <SCInput
              label={item.Description}
              onChange={(e: any) => onTableCellUpdate ? onTableCellUpdate(e.value) : handleFormItemChangeSC(e, item)}
              required={item.Required}
              value={itemValue}
              error={inputErrors[item.ID]}
              readOnly={disableField()}
            />
          </div>
        </div> :
        item.DataType == Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.LongText) ?
          <div className="row">
            <div className="column">
              <SCTextArea
                label={item.Description}
                onChange={(e: any) => onTableCellUpdate ? onTableCellUpdate(e.value) : handleFormItemChangeSC(e, item)}
                required={item.Required}
                value={itemValue}
                error={inputErrors[item.ID]}
                readOnly={disableField()}
              />
            </div>
          </div> :
          item.DataType == Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Number) ?
            <div className="row">
              <div className="column">
                <SCNumericInput
                  label={item.Description}
                  onChange={(e: any) => onTableCellUpdate ? onTableCellUpdate(e.value?.toString()) : handleFormItemChangeSC(e, item)}
                  required={item.Required}
                  value={itemValue}
                  error={inputErrors[item.ID]}
                  readOnly={disableField()}
                />
              </div>
            </div> :
            item.DataType == Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Checkbox) ?
              <div className="row">
                <div className="column">
                  <SCCheckbox
                    label={item.Description}
                    onChange={() => onTableCellUpdate ? onTableCellUpdate(!Helper.stringToBool(itemValue) ? "true" : "false") : handleCheckboxFormItemChange(item)}
                    value={itemValue}
                    extraClasses="form"
                    disabled={disableField()}
                  />
                </div>
              </div> :
              item.DataType == Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Boolean) ?
                <div className="row">
                  <div className="column">
                    <SCDropdownList
                      label={item.Description}
                      options={["Yes", "No"]}
                      value={itemValue}
                      required={item.Required}
                      onChange={(option: any) => onTableCellUpdate ? onTableCellUpdate(option) : setValue(option, item)}
                      error={inputErrors[item.ID]}
                      disabled={disableField()}
                      canClear={true}
                    />
                  </div>
                </div> :
                item.DataType == Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Date) ?
                  <div className="row">
                    <div className="column">
                      <SCDatePicker
                        label={item.Description}
                        required={item.Required}
                        changeHandler={(e: any) => onTableCellUpdate ? handleDateFormItemChangeSC(e, item, onTableCellUpdate) : handleDateFormItemChangeSC(e, item)}
                        value={itemValue}
                        error={inputErrors[item.ID]}
                        disabled={disableField()}
                      />
                    </div>
                  </div> :
                  item.DataType == Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.DateTime) ?
                    <div className="row">
                      <div className="column">
                        <SCDatePicker
                          label={item.Description}
                          required={item.Required}
                          changeHandler={(e: any) => onTableCellUpdate ? handleDateFormItemChangeSC(e, item, onTableCellUpdate) : handleDateFormItemChangeSC(e, item)}
                          value={itemValue}
                          error={inputErrors[item.ID]}
                          disabled={disableField()}
                        />
                      </div>
                      <div className="column">
                        <SCTimePicker
                          changeHandler={(e: any) => onTableCellUpdate ? handleDateTimeFormItemChangeSC(e, item, onTableCellUpdate) : handleDateTimeFormItemChangeSC(e, item)}
                          label=""
                          required={item.Required}
                          disabled={disableField()}
                          value={itemValue}
                          error={inputErrors[item.ID]}
                          format="HH:mm:ss"
                        />
                      </div>
                    </div> :
                    item.DataType == Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Select) ?
                      <div className="row">
                        <div className="column">
                          <SCDropdownList
                            label={item.Description}
                            required={item.Required}
                            options={getDataOptions(field)}
                            onChange={(option: any) => onTableCellUpdate ? onTableCellUpdate(option) : setValue(option, item)}
                            value={itemValue}
                            error={inputErrors[item.ID]}
                            disabled={disableField()}
                          />
                        </div>
                      </div> :
                      item.DataType == Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.MultiSelect) ?
                        <div className="row">
                          <div className="column">
                            <SCMultiSelect
                              label={item.Description}
                              required={item.Required}
                              availableOptions={getDataOptions(field)}
                              onChange={(option: any) => onTableCellUpdate ? setValueMultipleSC(option, item, onTableCellUpdate) : setValueMultipleSC(option, item)}
                              selectedOptions={getSelectedDataOptions(item)}
                              error={inputErrors[item.ID]}
                              disabled={disableField()}
                            />
                          </div>
                        </div> :
                        item.DataType == Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Table) ?
                          <>{plotFormItemTable(item, field)}</>
                          :
                          item.DataType === Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Image) ?
                            <>
                              {item.Description ? <div style={{ marginTop: "0.5rem" }}>
                                <span style={{ marginRight: "0.5rem", marginTop: "0.5rem" }}>
                                  {item.Description} {item.Required ? <span style={{ color: "#fa5252" }}>*</span> : ""}
                                </span>
                              </div> : ""}


                              {!!item.DataResult ? <div style={{ marginTop: "0.5rem" }}>
                                <div style={{ width: "fit-content", paddingLeft: "0.5rem", paddingRight: "0.5rem" }}>

                                  <div
                                    style={{
                                      height: "150px", width: "150px", position: 'relative', cursor: 'zoom-in', '&:hover': {
                                        height: 50
                                      }
                                    }}
                                    onClick={() => setPreviewAttatchmentItem(item)}
                                  >
                                    <Image quality={40} src={getImgSrc(item.DataResult)} alt={''} fill style={{ objectPosition: 'center', objectFit: 'cover' }} />
                                  </div>

                                  {/*<img onClick={() => setPreviewAttatchmentItem(item)} src={getImgSrc(item.DataResult)}  />*/}

                                  {imageUploadMessage[item.ID] ? <span style={{ verticalAlign: "top", marginRight: "0.5rem", marginLeft: "0.5rem", fontStyle: "italic", opacity: 0.7 }}>{imageUploadMessage[item.ID]}</span> : ""}

                                  {!disableField() &&
                                    <div style={{ width: "auto", textAlign: "center" }}>
                                      <div style={{ marginRight: "0.5rem", display: "inline-block" }}>
                                        <img src="/icons/repeat-blue.svg" style={{ cursor: "pointer" }} title="Replace" onClick={() => {
                                          !disableField() && document.getElementById(`js-attachment-input-${itemID}`).click();
                                        }} />
                                        <input type="file" id={`js-attachment-input-${itemID}`} style={{ display: "none" }} onChange={(e: any) => handleAttachmentChange(e, item, onTableCellUpdate)} />
                                      </div>
                                      <img src="/icons/x-circle-red.svg" style={{ cursor: "pointer" }} title="Remove" onClick={() => {
                                        if (disableField()) {
                                          return;
                                        }
                                        setImageUploadMessage({
                                          ...imageUploadMessage,
                                          [item.ID]: undefined
                                        });
                                        onTableCellUpdate ? onTableCellUpdate(null) : handleFormItemChange({ target: { value: null } }, item);
                                      }} />

                                    </div>
                                  }
                                </div>


                              </div>
                                :
                                <div style={{ marginTop: "0.5rem" }}>
                                  <div style={{ fontSize: "0.75rem", textAlign: "right", margin: "0.2rem 0", color: (inputErrors[item.ID] ? "orange" : colors.labelGrey) }}>
                                    {inputErrors[item.ID] ? inputErrors[item.ID] : ""}
                                  </div>
                                  {/*<LegacyButton
                                    icon={"plus-circle-blue"}
                                    disabled={disableField()}
                                    extraClasses={`fit-content no-margin hollow`}
                                    text={`Add Image`}
                                    onClick={() => document.getElementById(`js-attachment-input-${itemID}`).click()}
                                  />*/}
                                  <Button
                                    disabled={disableField()}
                                    variant={'outline'}
                                    leftSection={<IconCirclePlus />}
                                    onClick={() => document.getElementById(`js-attachment-input-${itemID}`).click()}
                                  >
                                    Add Image
                                  </Button>

                                  <input type="file" id={`js-attachment-input-${itemID}`} style={{ display: "none" }} onChange={(e: any) => handleAttachmentChange(e, item, onTableCellUpdate)} />
                                </div>}

                            </>
                            :
                            item.DataType === Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.InformationalText) ?
                              <><div style={{ marginBottom: "1rem", marginTop: "1rem", fontSize: "0.85rem" }}>{item.Description?.split("\n").map((text: any) => {
                                return (<div key={'itemText' + text} style={{ marginTop: "0.5rem", minHeight: "0.5rem" }}>{text}</div>);
                              })}</div></> :
                              item.DataType === Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.InformationalImage) ?
                                <>
                                  <div
                                    style={{
                                      minHeight: "300px", minWidth: "100%", position: 'relative', cursor: 'zoom-in', '&:hover': {
                                        height: 50
                                      }
                                    }}
                                    onClick={() => setPreviewAttatchmentItem(item)}
                                  >
                                    <Image quality={40} src={getImgSrc(item.Description)} alt={''} fill style={{ objectPosition: 'center', objectFit: 'contain' }} />
                                  </div>
                                </>
                                :
                                item.DataType === Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Signature) ?
                                  <>
                                    <div style={{ marginTop: "0.5rem" }}>
                                      <div style={{
                                        fontSize: "0.875rem",
                                        fontWeight: 500,
                                        color: "#212529",
                                        marginBottom: "0.25rem"
                                      }}>{item.Description}</div>
                                      <LegacyButton
                                        disabled={disableField()}
                                        extraClasses={`fit-content no-margin hollow`}
                                        text={item.DataResult ? `View Signature` : `Sign Here`}
                                        onClick={async () => {
                                          if (isNew || !formHeader.CompletedDate) {
                                            await save(true);
                                          }
                                          setSignatureObject({
                                            title: JSON.parse(field.DataOption).Title,
                                            id: item.DataResult ? item.DataResult : null,
                                            request: item.DataResult ? null : {
                                              ItemID: item.ID,
                                              SignatureKey: Constants.signatureKeys.FormSignature,
                                              SignatureTemplateID: JSON.parse(field.DataOption).SignatureTemplateID,
                                              Title: "",
                                              Module: Enums.Module.FormHeader
                                              // CustomerID?: string
                                              // SupplierID?: string
                                              // EmployeeID?: string
                                            },
                                            onUpdate: (signature: any) => {
                                              if (!!signature.AttachmentID) {
                                                onTableCellUpdate ? onTableCellUpdate(signature?.ID) : setValue(signature?.ID, item);
                                              }
                                            }
                                          });
                                        }} />
                                      <div style={{ fontSize: "0.75rem", textAlign: "left", margin: "0.2rem 0", color: (inputErrors[item.ID] ? colors.warningRed : colors.labelGrey) }}>
                                        {inputErrors[item.ID] ? inputErrors[item.ID] : ""}
                                      </div>
                                    </div>
                                  </>
                                  : ''
    );

  }

  const getSectionsToRender = () => {
    let sectionGroups = [];
    let deletableSectionIDs = [];
    let maxSectionGroups = {};

    if (!formItems) return;

    // assumption - form items are in order

    let items = [...formItems];

    let updateFormItems = false;

    // preprocess the formitems so they fit the correct data structure
    for (let item of items) {
      if (!item.DataType) {
        // item is missing retrospective info, prepopulating
        let formDefinitionField = formDefinitionFields.find((x: any) => x.ID === item.FormDefinitionFieldID);
        if (!formDefinitionField) {
          continue;
        }

        let section = formDefinitionField.Section;
        item.DataType = formDefinitionField.DataType;
        item.Required = formDefinitionField.Required;
        item.SectionID = formDefinitionField.SectionID;
        item.SectionHeading = section ? section.Heading : null;
        item.SectionDescription = section ? section.Description : null;
        item.SectionRepeatable = section ? section.Repeatable : null;
        item.SectionDisplayOrder = section ? section.DisplayOrder : null;
        item.ParentSectionID = section ? section.ParentSectionID : null;
        item.ParentSectionGroup = 0;

        updateFormItems = true;
      }
    }

    if ((!formHeader.FormDefinitionDisplayName && !!formHeader.FormDefinition.Name) ||
      !formHeader.FormDefinitionDescription && !!formHeader.FormDefinition.Description) {
      let newFormHeader = { ...formHeader };
      newFormHeader.FormDefinitionDisplayName = formHeader.FormDefinition.Name;
      newFormHeader.FormDefinitionDescription = formHeader.FormDefinition.Description;
      setFormHeader(newFormHeader);
    }


    if (updateFormItems) {
      setFormItems(items);
      setFormItemsChanged((fic: any) => fic + 1);
      return;
    }

    items = items.sort((a: any, b: any) => {
      let sga = a.SectionGroup ? a.SectionGroup : 0;
      let sgb = b.SectionGroup ? b.SectionGroup : 0;
      let doa = a.DisplayOrder;
      let dob = b.DisplayOrder;
      if (sga > sgb) return 1;
      if (sga < sgb) return -1;
      if (doa > dob) return 1;
      if (doa < dob) return -1;
      return 0;
    });

    // process sectionsGroups now that they are in correct format, starting with parent sections only
    for (let item of items.filter((x: any) => !x.ParentSectionID)) {
      let sectionID = item.SectionID;
      let parentSectionID = item.ParentSectionID;
      let heading = item.SectionHeading;
      let parentSectionGroup = item.ParentSectionGroup;
      let sectionFormItems = [item];
      let childSections = [];
      let isRepeatable = item.SectionRepeatable;
      let displayOrder = item.SectionDisplayOrder;
      let itemSectionGroup = item.SectionGroup ? item.SectionGroup : 0;

      maxSectionGroups[sectionID] = itemSectionGroup;

      if (itemSectionGroup > 0 && !deletableSectionIDs.includes(`${sectionID}_${parentSectionGroup}`)) {
        deletableSectionIDs.push(`${sectionID}_${parentSectionGroup}`);
      }

      let sectionGroup = sectionGroups.find((x: any) => x.sectionID === sectionID && x.sectionGroup === itemSectionGroup);
      if (!!sectionGroup) {
        (sectionGroup as any).formItems.push(item);
      } else {
        sectionGroup = {
          sectionID,
          parentSectionID,
          heading,
          parentSectionGroup,
          formItems: sectionFormItems,
          childSections,
          isRepeatable,
          displayOrder,
          sectionGroup: itemSectionGroup,
          isDeletable: false,
          isLast: false,
          parentSectionGroupReference: null
        };
        sectionGroups.push(((sectionGroup as any) as any));
      }
    }

    // assumption: there is only one level of nesting - this could change but not practical, otherwise will need a tree based approach to populating children
    for (let item of items.filter((x: any) => !!x.ParentSectionID)) {
      let sectionID = item.SectionID;
      let parentSectionID = item.ParentSectionID;
      let heading = item.SectionHeading;
      let parentSectionGroup = item.ParentSectionGroup;
      let sectionFormItems = [item];
      let childSections = null; // assuming no grandchildren ever
      let isRepeatable = item.SectionRepeatable;
      let displayOrder = item.SectionDisplayOrder;
      let itemSectionGroup = item.SectionGroup ? item.SectionGroup : 0;

      maxSectionGroups[`${sectionID}_${parentSectionGroup}`] = itemSectionGroup;

      if (itemSectionGroup > 0 && !deletableSectionIDs.includes(`${sectionID}_${parentSectionGroup}`)) {
        deletableSectionIDs.push(`${sectionID}_${parentSectionGroup}`);
      }

      let sectionGroup = sectionGroups.find((x: any) => x.sectionID === sectionID && x.parentSectionGroup === parentSectionGroup && x.sectionGroup === itemSectionGroup);
      if (!!sectionGroup) {
        (sectionGroup as any).formItems.push(item);
      } else {
        let parent = sectionGroups.find((x: any) => x.sectionID === parentSectionID && x.sectionGroup === parentSectionGroup);
        sectionGroup = {
          sectionID,
          parentSectionID,
          heading,
          parentSectionGroup,
          formItems: sectionFormItems,
          childSections,
          isRepeatable,
          displayOrder,
          sectionGroup: itemSectionGroup,
          isDeletable: false,
          isLast: false,
          parentSectionGroupReference: parent
        };
        sectionGroups.push(((sectionGroup as any) as any));
        parent.childSections.push!!!(sectionGroup);
      }
    }

    sectionGroups.forEach((sg: any) => {
      if (deletableSectionIDs.includes(`${sg.sectionID}_${sg.parentSectionGroup}`)) {
        sg.isDeletable = true;
      }

      let maxSG = maxSectionGroups[sg.sectionID];
      let maxSGChild = maxSectionGroups[`${sg.sectionID}_${sg.parentSectionGroup}`];
      if (maxSG === sg.sectionGroup || maxSGChild === sg.sectionGroup) {
        sg.isLast = true;
      }
    });

    sectionGroups = sectionGroups.filter((x: any) => !x.parentSectionID).sort((a: any, b: any) => {
      let sia = a.sectionID !== null;
      let sib = b.sectionID !== null;
      let doa = a.displayOrder;
      let dob = b.displayOrder;
      let soa = a.sectionGroup;
      let sob = b.sectionGroup;
      if (sia && !sib) return 1;
      if (!sia && sib) return -1;
      if (doa > dob) return 1;
      if (doa < dob) return -1;
      if (soa > sob) return 1;
      if (soa < sob) return -1;
      return 0;
    });

    sectionGroups.forEach((sg: any) => {
      sg.childSections = sg.childSections.sort((a: any, b: any) => {
        let doa = a.displayOrder;
        let dob = b.displayOrder;
        let soa = a.sectionGroup;
        let sob = b.sectionGroup;
        if (doa > dob) return 1;
        if (doa < dob) return -1;
        if (soa > sob) return 1;
        if (soa < sob) return -1;
        return 0;
      });
    });

    setSectionsToRender(sectionGroups);

  };

  const deleteSectionGroupItem2 = (sectionGroup: any) => {

    let formItemsDummy = [...formItems];

    let isParent = sectionGroup.childSections && sectionGroup.childSections.length > 0;

    let idsToDelete = sectionGroup.formItems.map((x: any) => x.ID);
    if (isParent) {
      sectionGroup.childSections.forEach((cs: any) => {
        idsToDelete.push(...cs.formItems.map((x: any) => x.ID));
      });
    }

    formItemsDummy = formItemsDummy.filter((x: any) => !idsToDelete.includes(x.ID));

    let isChild = !sectionsToRender.find((x: any) => x.sectionID === sectionGroup.sectionID);

    let nextSectionGroups = [];

    if (isChild) {
      nextSectionGroups = sectionGroup.parentSectionGroupReference.childSections.filter((x: any) => x.sectionID === sectionGroup.sectionID
        && x.sectionGroup > sectionGroup.sectionGroup);
    } else {
      nextSectionGroups = sectionsToRender.filter((x: any) => x.sectionID === sectionGroup.sectionID
        && x.sectionGroup > sectionGroup.sectionGroup);
    }

    nextSectionGroups.forEach((sg: any) => {
      sg.formItems.forEach((item: any) => {
        let idx = formItemsDummy.findIndex((x: any) => x.ID === item.ID);
        if (idx > -1) {
          formItemsDummy[idx].SectionGroup--;
        }
      });
      let sgIsParent = sg.childSections && sg.childSections.length > 0;
      if (sgIsParent) {
        sg.childSections.forEach((cs: any) => {
          cs.formItems.forEach((item: any) => {
            let idx = formItemsDummy.findIndex((x: any) => x.ID === item.ID);
            if (idx > -1) {
              formItemsDummy[idx].ParentSectionGroup--;
            }
          });
        });
      }
    });

    setFormItems(formItemsDummy);
    setFormItemsChanged(formItemsChanged + 1);
  };

  const addNewSectionGroupItem2 = (sectionGroup: any) => {

    let newItems = [];
    let defaultSectionGroup = sectionGroup.sectionGroup ? sectionGroup.sectionGroup + 1 : 1;

    sectionGroup.formItems.forEach((formItemOriginal: any) => {
      let defaultParentSectionGroup = formItemOriginal.ParentSectionGroup;
      let item = getBlankFormItemFromOtherItem(formItemOriginal, defaultSectionGroup, defaultParentSectionGroup);
      newItems.push(((item as any) as any));
    });

    if (sectionGroup.childSections && sectionGroup.childSections.length > 0) {
      sectionGroup.childSections.filter((x: any) => x.sectionGroup === null || x.sectionGroup === 0).forEach((childSection: any) => {
        childSection.formItems.forEach((formItemOriginal: any) => {
          let item = getBlankFormItemFromOtherItem(formItemOriginal, 0, defaultSectionGroup);
          newItems.push(((item as any) as any));
        });
      });
    }

    let formItemsDummy = [...formItems];
    formItemsDummy.push(...newItems);

    setFormItems(formItemsDummy);
    setFormItemsChanged(formItemsChanged + 1);
  };


  const renderSections = (sectionsToRender: any) => {
    let canModify = !!formHeader && (formHeader.FormStatus === Enums.FormStatus.Draft ||
      (formHeader.FormStatus === Enums.FormStatus.Completed && formHeader.FormDefinition.ExpireTimespan === 0
        && formHeader.FormDefinition.FormRule === Enums.FormRule.Customer));

    return (<>
      {sectionsToRender.map((sectionGroup: any, groupKey: any) => {
        return (<>
          {!!previewAttatchmentItem && attachmentPreviewModal}

          {sectionGroup.heading && (sectionGroup.sectionGroup === null || sectionGroup.sectionGroup === 0) ? <h4 className="section-group">
            {sectionGroup.heading}
          </h4> : <></>}

          {sectionGroup.isRepeatable ? <>
            {/* repeatable code goes here */}

            <div className="section-group-item">

              <div className="row">
                <div className="column">
                  {sectionGroup.formItems.map((item: any, fieldKey: any) => {
                    return (<div key={groupKey * 1000 + fieldKey}>
                      {plotFormItemWithoutField(item)}
                    </div>)
                  })}
                </div>

                {sectionGroup.isDeletable && canModify ?
                  <div className="button-column">
                    <img alt="Delete" src="/icons/x-circle-blue.svg" height="24" onClick={() => deleteSectionGroupItem2(sectionGroup)} />
                  </div> : ""}

              </div>

              {!!sectionGroup.childSections && sectionGroup.childSections.length > 0 && renderSections(sectionGroup.childSections)}

            </div>

            {sectionGroup.isLast && canModify ? <LegacyButton text={`Add ${Helper.truncateText(sectionGroup.heading, 24)}`} extraClasses="no-margin fit-content" onClick={() => addNewSectionGroupItem2(sectionGroup)} icon="plus-circle" /> : ""}


          </> : <>
            {/* standard code goes here */}
            {sectionGroup.formItems.map((item: any, itemKey: any) => {
              return (<div key={groupKey * 1000 + itemKey}>
                {plotFormItemWithoutField(item)}
              </div>)
            })}
          </>}

        </>);
      })}


      <style jsx>{`
      
      .section-group {
        width: calc(100% - 1rem);
        // background: ${colors.lightGreyStatus};
        // padding: 4px 8px;
        // border-radius: 3px;
        // color: white;
        margin: 0;
        margin-top: 0.5rem;
      }

      .section-group-item {
        // box-shadow: ${shadows.cardSmallDark};
        border: 2px solid ${colors.borderGrey};
        border-radius: 3px;
        margin: 0.5rem 0;
        padding: 0 0.5rem 0.5rem 0.5rem;
      }

      .button-column {
        width: auto;
        padding: 0.5rem;
        text-align: -webkit-center;
      }

      .button-column img {
        cursor: pointer;
      }

      .row {
        display: flex;
        justify-content: space-between;
      }
      .column {
        display: flex;
        flex-direction: column;
        width: 100%;
      }
      .column + .column {
        margin-left: 1.25rem;
      }        

      `}</style>
    </>);
  };

  const canUpgrade = () => {
    return formHeader && formHeader.FormStatus === Enums.FormStatus.Draft && formHeader.LatestFormDefinitionID && formHeader.LatestFormDefinitionID !== formHeader.FormDefinitionID;
  }

  const onUpgrade = async () => {

    setConfirmOptions({
      ...Helper.initialiseConfirmOptions(),
      display: true,
      confirmButtonText: "Upgrade Form",
      heading: "Confirm upgrade form?",
      text: "The form will take on the new structure",
      onConfirm: async () => {
        let payload = {
          ...formHeader,
          FormItems: formItems
        };

        let resultFormHeader = await Fetch.post({
          url: "/Form/Upgrade",
          params: payload
        });

        setFormItems(resultFormHeader.FormItems);
        setFormHeader(resultFormHeader);
        getFormDefinitionFields(resultFormHeader);
        setFormItemsChanged(formItemsChanged + 1);
      }
    })
  }

  const refreshFormSignatures = async () => {
    let resultFormHeader = await Fetch.get({
      url: `/Form?id=${formHeader.ID}`
    });

    // iterate through existing form items and check if they have linked signatures, if so, overwrite the refreshed values to retain for saving
    formItems?.filter((x: any) => x.DataType === Enums.getEnumStringValue(Enums.FormDefinitionFieldTypes, Enums.FormDefinitionFieldTypes.Signature)).forEach((item: any) => {
      let matchIdx = resultFormHeader.FormItems.findIndex((x: any) => x.ID === item.ID);
      if (matchIdx > -1) {
        // don't overwrite refreshed data unless it is empty
        if (helper.isNullOrWhitespace(resultFormHeader.FormItems[matchIdx].DataResult)) {
          resultFormHeader.FormItems[matchIdx].DataResult = item.DataResult;
        }
      }
    });

    save(true, resultFormHeader);
  };

  if (!retrievedFields) {
    return (<h4>Loading...</h4>)
  }

  return (
    <SCModal open={true} >
      {/*<div className="overlay" onClick={(e) => e.stopPropagation()}>
      <div className="modal-container"></div>*/}

      <Box>

        <div>
          {formHeaderToManage.FormDefinition ? <>

              <Flex align={'start'} justify={'space-between'}>
                  <Title order={2}>{formHeader ? formHeader.FormDefinitionDisplayName : formHeaderToManage.FormDefinition.Name} {isExpired() ? "(EXPIRED)" : ""}</Title>
                  <Box ml={'auto'}>
                      <Text c={'gray.7'} mt={'xs'} size={'sm'} inline style={{whiteSpace: 'nowrap'}}>
                        Version {formHeader?.FormDefinition?.Version}
                      </Text>

                      {
                          formHeader && !formHeader._isNew ?
                          <span className="img-container">
                            {isPrinting ? <SCSpinner colour='dark' /> :
                                <img className="pointer" src="/icons/printer-blue.svg" alt="Print form" title="Print form"
                                     onClick={() => printFormHeader(formHeader)} />
                            }
                          </span> : ''
                      }

                      {
                          formHeader && formHeader.FormStatus === Enums.FormStatus.Completed && (isExpired() || willExpire()) ?
                              <>
                                  <span className="img-container">
                                    <img className="pointer" src="/icons/repeat-blue.svg" alt="renew"
                                         title={`Renew${isExpired() ? " expired" : ""} form`}
                                         onClick={() => onRenew(formHeaderToManage)} />
                                  </span>
                              </> : ""
                      }

                      {canUpgrade() ?
                          <>
                    <span className="img-container">
                      <img className="pointer" src="/icons/upload.svg" alt="upgrade" title="Upgrade form"
                           onClick={() => onUpgrade()} />
                    </span>
                          </>
                          :
                          ""}

              </Box>
              </Flex>
              <Text size={'sm'} c={'gray.7'} mt={'sm'}>
                  {formHeader ? formHeader.FormDefinitionDescription : formHeaderToManage.FormDefinition.Description}
              </Text>
          </> : ''
          }
        </div>

        {renderSections(sectionsToRender)}

        <Flex justify={'space-between'} align={'end'} mt={'md'} w={'100%'} wrap={'wrap'} gap={'sm'}>
          <div >
            {/*<LegacyButton text="Cancel" extraClasses="hollow" onClick={() => onSave(null)}/>*/}
            <Button variant={'outline'} onClick={() => onSave(null)}> Cancel</Button>
          </div>
          {formHeader ? <>
            {formHeader.FormStatus === Enums.FormStatus.Draft ? <Flex justify={'end'} align={'end'} gap={'xs'} direction={{ base: 'column', xs: 'row' }}>
              <div >
                {/*<LegacyButton text="Save Draft" extraClasses="hollow" onClick={() => save(false)} disabled={saving}/>*/}
                <Button variant={'outline'} onClick={() => save(false)} disabled={saving}>
                  Save Draft
                </Button>
              </div>
              <div >
                {/*<LegacyButton text="Complete" onClick={completeCheck} disabled={saving}/>*/}
                <Button onClick={completeCheck} disabled={saving}>
                  Complete
                </Button>
              </div>
            </Flex> : ""}
            {formHeader.FormStatus === Enums.FormStatus.Completed && formHeader.FormDefinition.ExpireTimespan === 0 && formHeader.FormDefinition.FormRule === Enums.FormRule.Customer ?
              <div>
                <div>
                  <LegacyButton text="Update" extraClasses="" onClick={() => save(false)} disabled={saving} />
                </div>
              </div> : ""}
          </> : ""
          }
        </Flex>
      </Box>

      <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

      {signatureObject &&
        <SignatureModal
          title={"Signature"}
          request={signatureObject.request}
          id={signatureObject.id}
          onUpdate={signatureObject.onUpdate}
          onDismiss={() => {
            refreshFormSignatures();
            setSignatureObject(null);
          }}
        />
      }
      <style jsx>{`

        :global(.title) {
          position: relative;
        }

        :global(.modal-container) {
          width: max-content;
          max-width: 90%;
          min-width: 38rem;
        }

        .version {
          font-size: 0.8rem;
          opacity: 0.7;
          margin-right: 0.5rem;
          vertical-align: top;
        }

        .section-group {
          width: calc(100% - 1rem);
            // background: ${colors.lightGreyStatus};
          // padding: 4px 8px;
          // border-radius: 3px;
          // color: white;
          margin: 0;
          margin-top: 0.5rem;
        }

        .section-group-item {
            // box-shadow: ${shadows.cardSmallDark};
          border: 2px solid ${colors.borderGrey};
          border-radius: 3px;
          margin: 0.5rem 0;
          padding: 0 0.5rem 0.5rem 0.5rem;
        }

        .button-column {
          width: auto;
          padding: 0.5rem;
          text-align: -webkit-center;
        }

        .button-column img {
          cursor: pointer;
        }

        .float-right {
          position: absolute;
          right: 0;
        }

        .float-right img {
          cursor: pointer;
        }

        .img-container {
          margin-left: 0.25rem;
        }

        .inline-block {
          display: inline-block;
          margin-left: 1rem;
        }

        .row {
          display: flex;
          justify-content: space-between;
        }

        .column {
          display: flex;
          flex-direction: column;
          width: 100%;
        }

        .column + .column {
          margin-left: 1.25rem;
        }

        .end {
          align-items: flex-end;
        }

        .header {
          font-weight: bold;
        }

        .button-widths {
          width: 6rem;
        }

        .left-padding {
          padding-left: 0.5em;
        }

        .right-padding {
          padding-right: 0.5em;
        }
      `}</style>
    </SCModal>
  );
}

export default ManageForm;
